import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RequirementTypeEnumDTO from 'features/requirements/dtos/RequirementTypeEnumDTO';
import React from 'react';
import { useHistory } from 'react-router-dom';

interface Props {
  type: RequirementTypeEnumDTO;
  handleCloseDialog: () => void;
}

const RequirementType = ({ type, handleCloseDialog }: Props) => {
  // history
  const history = useHistory();

  // handlers
  const openCreateRequirementHandler = () => {
    history.push(`/requirements/create/${type.code}`);
    handleCloseDialog();
  }

  // render
  return (
    <div className="list-group-item list-group-item-action py-2" role="button" onClick={openCreateRequirementHandler}>
      <div className="d-flex align-items-center">
          <span className="mr-3">{type.name}</span>
          <span className="text-muted ml-auto">
            <FontAwesomeIcon icon="chevron-right" size="sm"/>
          </span>
        </div>
    </div>
  )
}

export default RequirementType;
